import axios from 'axios';

export const getUserTagLogs = search => axios.get('/backoffice/user_tag_logs/', { params: { ...search } });

export const getUserTagLogFilters = () => axios.get('/backoffice/user_tag_logs/filters/');

export const exportUserTagLogs = search =>
  axios.get('/backoffice/user_tag_logs/export/', { params: { ...search }, responseType: 'blob' });
